'use client';
import Link from 'next/link';
import { SocialIcon, socialIcons } from './svg/socials/SocialsIcons';
import Share from './svg/Share';
import { useEffect, useState } from 'react';
import { sharableSocials } from '../../utils/socialMedia';
import { ILocalizedParams } from '../../models/ICommon';


export default function SharePost({ locale }: ILocalizedParams) {
  const [render, setRender] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const desiredIcons = [SocialIcon.facebook, SocialIcon.x, SocialIcon.whatsapp, SocialIcon.linkedin];
  const icons = Object.values(socialIcons).filter(x => desiredIcons.includes(x.type));

  useEffect(() => {
    setRender(true);
  }, []);

  if (!render) return null;
  return (
    <div className="share-posts flex fixed top-[71px] desktop:hidden w-full justify-center left-0 z-10 items-center h-fit tablet:w-fit bg-white dark:bg-night-100 rtl:tablet:ml-[2.5%] ltr:tablet:mr-[2.5%] rounded-br-[24px] rounded-bl-[24px] gap-x-[20px] px-[24px]">
      {/* <div className='h-full cursor-pointer grid place-items-center' onClick={() => setCollapsed(!collapsed)}>
        <Share className='h-[36px] w-[36px]'/>
      </div> */}
      {icons.map(({ Component, href, type }) => (
        <Link hrefLang={locale} target='_blank' rel='noopener noreferrer' title={type} key={type} href={sharableSocials(`${window.location.origin}${window.location.pathname}`)[type]!} className='w-[36px] h-[36px]'>
          <Component className='h-full w-full' />
        </Link>
      ))}
    </div>
  )
}